"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyCreatePodcastV1StudioPodcastsPostQualityPreset = void 0;
exports.BodyCreatePodcastV1StudioPodcastsPostQualityPreset = {
    Standard: "standard",
    High: "high",
    Highest: "highest",
    Ultra: "ultra",
    UltraLossless: "ultra_lossless",
};
